import axios from 'axios';
import { TOKEN_KEY } from './constants';

let API_URL = 'https://api.gosnel.com';
const ENV_API = import.meta.env.VITE_API_BASE_URL;
if (ENV_API && ENV_API !== 'undefined' && !String(ENV_API).includes('192.168')) {
  API_URL = ENV_API;
  if (API_URL.startsWith('http://') && !API_URL.includes('localhost')) {
    API_URL = API_URL.replace('http://', 'https://');
  }
}

if (typeof window !== 'undefined') {
  const host = (window.location.hostname || '').toLowerCase();
  const onGosnel =
    host === 'gosnel.com' ||
    host.endsWith('.gosnel.com') ||
    host.endsWith('.pages.dev');
  if (onGosnel && (API_URL.includes('localhost') || API_URL.includes('127.0.0.1'))) {
    API_URL = 'https://api.gosnel.com';
  }
}

const api = axios.create({
  baseURL: API_URL,
  timeout: 60000,
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
  },
});

function readToken() {
  try {
    return localStorage.getItem(TOKEN_KEY) || sessionStorage.getItem(TOKEN_KEY) || '';
  } catch {
    return '';
  }
}

function clearAuthStorage() {
  try {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem('lp_vendor');
    sessionStorage.removeItem('lp_vendor');
  } catch {
    /* ignore */
  }
}

api.interceptors.request.use((config) => {
  const token = readToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      clearAuthStorage();
      if (
        typeof window !== 'undefined' &&
        !window.location.pathname.startsWith('/auth/admin-login')
      ) {
        window.location.assign('https://auth.gosnel.com');
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiError(err, fallback = 'Request failed') {
  const detail = err?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || d?.message || String(d)).filter(Boolean).join(' · ') || fallback;
  }
  return err?.message || fallback;
}

export default api;
